module.exports = __webpack_public_path__ + "static/media/pax-logo.0c442ce9.png";